import { defineStore } from 'pinia';
import { Router } from 'vue-router';
import { UserStore } from './UserStore.interface';
import { LoginRequestData } from '@/services/requests/AuthRequest/AuthRequest.interface';
import { UserModel } from '@/services/requests/UsersRequest/UsersRequest.interface';

export const useUserStore = defineStore({
	id: 'UserStore',
	state: (): UserStore => ({
		user: undefined,
		userEdit: Object.create({}),
	}),
	getters: { },
	actions: {
		async login(loginData: LoginRequestData) {
			const { error: csrfError } = await fetcher(AuthRequest.crsf());
			csrfError && console.log(csrfError);

			if (!csrfError) {
				const { data: user, error } = await fetcher(AuthRequest.login(loginData));

				if (error) {
					return Promise.reject(error);
				}
	
				return user && (
					this.user = user.data
				);
			}
		},
		async authenticate() {
			const { data: user, error } = await fetcher(AuthRequest.getMe());
			if (error) {
				this.user = undefined;

				return Promise.reject(error);
			}
			user && (
				this.user = user.data,
				user
			);
		},
		async getUser() {
			const { data: user } = await fetcher(AuthRequest.getMe());
			user && (
				this.user = user.data,
				user
			);
		},
		setEdit(user: UserModel) {
			this.userEdit = user;
		},
		async logout() {
			await fetcher(AuthRequest.logout());
			this.$reset();
		},
		async logout401(router: Router) {
			this.$reset();
			router.push({
				path: '/login',
			});
		},
	},
});

export default useUserStore;
